import React from 'react'
import { LayoutBand, Separator, useContainerWidth } from '@fs/zion-ui'
import backgroundImage from '../../assets/background.svg'

const pageStyleDefault = {
  minWidth: '100%',
}

const styles = {
  default: {
    pageStyle: pageStyleDefault,
  },
  lg: {
    pageStyle: pageStyleDefault,
    image: backgroundImage,
    headerFooterSeparator: true,
    childPageStyle: { borderRadius: 6 },
  },
}

export default function PageWrapper({ children, ...props }) {
  const { pageStyle, image, headerFooterSeparator, childPageStyle } = useContainerWidth()(styles)
  return (
    <LayoutBand maxWidth="xxs" image={image} style={pageStyle} {...props}>
      {headerFooterSeparator && <Separator size="sm" />}
      <LayoutBand color="white" style={childPageStyle}>
        <Separator size="xs" />
        {children}
        <Separator size="lg" />
      </LayoutBand>
      {headerFooterSeparator && <Separator size="sm" />}
    </LayoutBand>
  )
}
